import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { VariantType } from 'notistack'
import type { RootState } from '../store'

type SnackBar={
  value:string,mode?:VariantType
}
// Define the initial state using that type
const initialState:SnackBar = {
  value: '',
  mode:'default'
}

export const snackbarMessageSlice = createSlice({
  name: 'snackBarMessage',
  initialState,
  reducers: {
    setSnackbarMessage: (state, action: PayloadAction<SnackBar>) => {
      state.value = action.payload.value
      if (action.payload.mode){
        state.mode=action.payload.mode
      }
    }
  }
})

export const { setSnackbarMessage } = snackbarMessageSlice.actions

export const selectSnackbarMessage = (state: RootState) => state.snackBarMessage.value

export default snackbarMessageSlice.reducer
